var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"tn-section"},[_c('h2',{staticClass:"tn-section__title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }